import { render } from "./partnerDetail.vue?vue&type=template&id=0966c7cc&scoped=true"
import script from "./partnerDetail.vue?vue&type=script&lang=js"
export * from "./partnerDetail.vue?vue&type=script&lang=js"

import "./partnerDetail.vue?vue&type=style&index=0&id=0966c7cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0966c7cc"]])

export default __exports__